// extracted by mini-css-extract-plugin
module.exports = {"option":"Locations_option__3m25z","flag":"Locations_flag__2IG7V","marker":"Locations_marker__2lHHt"};